import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar";
import Navbar from "../Navbar";
import axios from "axios";
import { Card } from "react-bootstrap";
import toastr from "toastr";

const CreatePayment = () => {
  const authToken = localStorage.getItem("disToken");
  const [bal, setBal] = useState("");
  const [amount, setAmount] = useState(0);

  async function getBalance() {
    try {
      const response = await axios.get(
        "http://api.meddaily.in/get_payout_amount",
        {
          headers: {
            token: authToken,
          },
        }
      );

      if (response.status === 200) {
        setBal(response?.data?.data);
        console.log("response", response.data.data);
      }
    } catch (err) {
      console.log(err);
    }
  }

  async function createPayout() {
    if (amount === 0 || amount === "" || amount > bal.amount) {
      toastr.warning("Invalid amount");
      return;
    }
    try {
      const response = await axios.post(
        "http://api.meddaily.in/create_payout",
        {
          amount: amount,
        },
        {
          headers: {
            token: authToken,
          },
        }
      );

      if (response.status === 200) {
        toastr.success(response?.data?.message);
      }
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    getBalance();
  }, []);

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <Sidebar />
        <div className="layout-page">
          <Navbar />

          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <div className="row">
                <div className="card mb-12">
                  <div className="card-body">
                    <div className="container-xxl flex-grow-1 container-p-y">
                      <div className="row">
                        <div className="card">
                          <div>
                            <Card>
                              <Card.Body>
                                <Card.Title>
                                  <h1>Amount</h1>
                                </Card.Title>
                                <Card.Text>
                                  <h3>{bal.amount}</h3>
                                </Card.Text>
                              </Card.Body>
                            </Card>
                          </div>
                          <div className="mt-3">
                            <h3 className="text-start">PayOut Request</h3>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="text-start">
                                <label htmlFor="amt">Enter Amount</label>
                                <input
                                  type="number"
                                  name="amt"
                                  id="amt"
                                  className="form-control"
                                  value={amount}
                                  onChange={(e) => setAmount(e.target.value)}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="mt-5 mb-5">
                            <button
                              className="btn btn-primary"
                              onClick={createPayout}
                              style={{
                                backgroundColor: "#6eafab",
                                border: "1px solid #6eafab",
                              }}
                            >
                              Request
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreatePayment;
